// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //apiUrl: 'https://localhost:44330' //HUTSA
  // apiUrl: 'https://localhost:44335' //ERIS 
  apiUrl: 'https://erisberriapi.zitu.net' 
  // apiUrl: 'https://erisapi.zitu.net'
  //apiUrl: 'https://localhost:44332' //RESERVAONLINE
  //apiUrl: 'https://localhost:44333' //AIORA
  //apiUrl: 'https://localhost:44334' //TTTGOIKO

  //apiUrl: 'http://localhost:7200' //HUTSA
  //apiUrl: 'http://localhost:7201' //ERIS
  //apiUrl: 'http://localhost:7202' //RESERVAONLINE
  //apiUrl: 'http://localhost:7203' //AIORA
  //apiUrl: 'http://localhost:7204' //TTTGOIKO
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
